const storageKey = "cartPreselectedConditions";

export const markConditionsAsCartPreselected = (
  conditionNames: string[]
): void => {
  sessionStorage.setItem(storageKey, JSON.stringify(conditionNames));
};

export const isConditionCartPreselected = (
  conditionName: string
): boolean => {
  const stored = sessionStorage.getItem(storageKey);
  if (!stored) return false;
  const names: string[] = JSON.parse(stored);
  return names.includes(conditionName);
};

export const clearCartPreselection = (): void => {
  sessionStorage.removeItem(storageKey);
};
